
import Vue from "vue";
import { HTTP } from '@/axios_api/http-common';
import * as XLSX from 'xlsx';
export default Vue.extend({
    props: ["height", "selectedProjectId", "useDailyReport"],
    data() {
        return {
            cumulativeCost: { tableId: '', columns: [] } as { tableId: '', columns: { columnName: string; values: string[] }[] },
            search: "",
            actionFilter: "All",
            categoryFilter: "All",
            fields: [
                { key: 'Name', label: 'Activity' },
                { key: 'Duration', label: 'Plan Cost (K$)', class: 'text-center' },
                { key: 'ActualDuration', label: 'Actual Cost (K$)', class: 'text-center' },
            ],
        }
    },
    computed: {
        computedTableData(): Array<any> {
            if (this.cumulativeCost.columns.length) {
                let arr = [];
                for (let i = 0; i < this.cumulativeCost.columns[0].values.length; i++) {
                    // if (i === 0) continue;
                    arr.push({
                        Name: this.cumulativeCost.columns[0].values[i],
                        Duration: this.cumulativeCost.columns[1].values[i],
                        ActualDuration: this.cumulativeCost.columns[2].values[i],
                    })
                }
                return arr
            }

            return []
        },

        getHeader(): string {
            return "Cumulative Cost " + this.getProjectNameFromId(this.selectedProjectId)
        }
    },
    methods: {exportToExcel() {
            const exportData = this.computedTableData.map(row => ({
                "Activity": row.Name,
                "Plan Cost (K$)": row.Duration,
                "Actual Cost (K$)": row.ActualDuration
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);

            // Calculate column widths based on data
            type ExportDataKey = "Activity" | "Plan Cost (K$)" | "Actual Cost (K$)";
            const columnWidths = Object.keys(exportData[0] || {}).map(key => {
                const typedKey = key as ExportDataKey;
                const maxLength = Math.max(
                key.length,
                ...exportData.map(row => (row[typedKey] ? String(row[typedKey]).length : 0))
                );
                return { wch: maxLength + 2 }; // Add some padding
            });

            // Apply column width
            ws['!cols'] = columnWidths;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Cumulative Cost Table");

            const fileName = `Cumulative_Cost_Table_${this.getProjectNameFromId(this.selectedProjectId)}.xlsx`;
            XLSX.writeFile(wb, fileName);
        },
        fetchData() {
            HTTP.get(`analytics/query/activitycumulativecost/${this.selectedProjectId}?useDailyReport=${this.useDailyReport}`)
                .then((response: any) => {
                    this.cumulativeCost = response.data.data
                })
                .catch((error: any) => {

                })
        },

        getProjectNameFromId(id: any) {
            const project = this.$store.getters["projectModule/getProjectById"](id);
            return project && project.name ? project.name : "";
        },
    },
    mounted() {
        this.fetchData()
    },
    watch: {
        cumulativeCost: {
            handler() {
                if (!this.cumulativeCost.columns.length) {
                    this.fetchData()
                }
            }
        }
    }
})
